import { prepareGalleryCardData } from '../helpers/carouselHelper';
import { getContainerType } from '../helpers/commonHelpers';
import { CARD_TYPES } from '../../../constants';
import { prepareTranslations as videoTranslations } from './video';

import * as videoMethods from './video';
import * as imageMethods from './image';

export const prepareCardData = (cardData, data) => {
  // no need for carousel if there is only 1 slide
  if (cardData?.nodes?.length === 1) {
    const slideID = cardData?.nodes[0];
    if (getContainerType(data?.nodes[slideID]) === 'video') {
      return videoMethods.prepareCardData(data?.nodes[slideID], data);
    }
    return imageMethods.prepareCardData(data?.nodes[slideID], data);
  }
  return prepareGalleryCardData(cardData, data, CARD_TYPES.AUTOPLAY);
};
export const prepareTranslations = (translationsStrings = {}) => ({
  autoplayCarousel: translationsStrings.autoplay_carousel,
  autoplayPauseButtonLabel: translationsStrings.autoplay_pause_button_label,
  autoplayResumeButtonLabel: translationsStrings.autoplay_resume_button_label,
  autoplaySlideNumber: translationsStrings.autoplay_carousel_slide_number,
  nextButton: translationsStrings.next,
  paginationTitle: translationsStrings.pagination_title,
  prevButton: translationsStrings.previous,
  ...videoTranslations(translationsStrings),
});

export {
  getGalleryUrlIngredients as getUrlIngredients,
  mergeGalleryProperties as mergeProperties,
} from '../helpers/carouselHelper/carouselHelper';

export {
  getGalleryPlacements as getAnalyticsPlacements,
  getGalleryActions as getAnalyticsActions,
} from '../helpers/analytics';

export { getBuyingToolsIngredients } from './common';
